/* 
NB! Updates on these constants will affect all pages using these constants. 
Remember to go over all cases where these constants are used to make sure no 
unfortunate color updates is made to components, if these constans are changed.
*/

export default {
  // ==== Primary palette === //
  primary: "#0a283f",
  secondary: "#ffa634",
  KDprimary: "#802365",
  KDlightPurple: "#C382BD",
  KDlogo: "#7A1E64",
  blue: "#294f6e",
  darkGray: "#2f353b",
  textGray: "#919EA9",

  // ==== Secondary palette === //
  green: "#59c09c",
  red: "#e06565",
  white: "#ffffff",
  gray: "#efefef",
};
